import React from 'react';
import { GetAssureDetailsResponse } from 'api/actor';
import PersonOverview from '../../PersonOverview';

interface PersonGeneralInfoProps {
  personDetails: GetAssureDetailsResponse;
}

const PersonGeneralInfo: React.FC<PersonGeneralInfoProps> = ({ personDetails }) => {
  const details = personDetails.details;

  if (!details) {
    return <div>Aucune information disponible</div>;
  }

  return <PersonOverview person={details} />;
};

export default PersonGeneralInfo;
